export default "__VITE_ASSET__CLQY5cw4__"